// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import App__CriterionCompletionRequirementFormController from "./app/criterion_completion_requirement_form_controller"
application.register("app--criterion-completion-requirement-form", App__CriterionCompletionRequirementFormController)

import App__CriterionGoalFormController from "./app/criterion_goal_form_controller"
application.register("app--criterion-goal-form", App__CriterionGoalFormController)

import App__CriterionPeriodFormController from "./app/criterion_period_form_controller"
application.register("app--criterion-period-form", App__CriterionPeriodFormController)

import App__GrantFilterController from "./app/grant_filter_controller"
application.register("app--grant-filter", App__GrantFilterController)

import App__MeritInputController from "./app/merit_input_controller"
application.register("app--merit-input", App__MeritInputController)

import App__MeritInputsController from "./app/merit_inputs_controller"
application.register("app--merit-inputs", App__MeritInputsController)

import App__ParticipantFormController from "./app/participant_form_controller"
application.register("app--participant-form", App__ParticipantFormController)

import App__ParticipantsListController from "./app/participants_list_controller"
application.register("app--participants-list", App__ParticipantsListController)

import App__SessionActivityController from "./app/session_activity_controller"
application.register("app--session-activity", App__SessionActivityController)

import App__SessionActivityIndicatorsController from "./app/session_activity_indicators_controller"
application.register("app--session-activity-indicators", App__SessionActivityIndicatorsController)

import App__SessionDateController from "./app/session_date_controller"
application.register("app--session-date", App__SessionDateController)

import App__SessionParticipantActivityFormRowController from "./app/session_participant_activity_form_row_controller"
application.register("app--session-participant-activity-form-row", App__SessionParticipantActivityFormRowController)

import App__SessionParticipantItemController from "./app/session_participant_item_controller"
application.register("app--session-participant-item", App__SessionParticipantItemController)

import App__SessionRelationshipsController from "./app/session_relationships_controller"
application.register("app--session-relationships", App__SessionRelationshipsController)

import App__SessionTemplateSelectController from "./app/session_template_select_controller"
application.register("app--session-template-select", App__SessionTemplateSelectController)

import App__UploadArtifactsController from "./app/upload_artifacts_controller"
application.register("app--upload-artifacts", App__UploadArtifactsController)

import App__UserFacilitatorFormController from "./app/user_facilitator_form_controller"
application.register("app--user-facilitator-form", App__UserFacilitatorFormController)

import App__UserParticipantFormController from "./app/user_participant_form_controller"
application.register("app--user-participant-form", App__UserParticipantFormController)

import ApplicationController from "./application_controller"
application.register("application", ApplicationController)

import AsyncFormController from "./async_form_controller"
application.register("async-form", AsyncFormController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import AutofocusController from "./autofocus_controller"
application.register("autofocus", AutofocusController)

import ChartJsController from "./chart_js_controller"
application.register("chart-js", ChartJsController)

import ChoicesController from "./choices_controller"
application.register("choices", ChoicesController)

import CkeditorController from "./ckeditor_controller"
application.register("ckeditor", CkeditorController)

import CkeditorInlineController from "./ckeditor_inline_controller"
application.register("ckeditor-inline", CkeditorInlineController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapseElementsController from "./collapse_elements_controller"
application.register("collapse-elements", CollapseElementsController)

import ContentEditableFormController from "./content_editable_form_controller"
application.register("content-editable-form", ContentEditableFormController)

import DelayHideController from "./delay_hide_controller"
application.register("delay-hide", DelayHideController)

import DeleteElementController from "./delete_element_controller"
application.register("delete-element", DeleteElementController)

import DirtyElementController from "./dirty_element_controller"
application.register("dirty-element", DirtyElementController)

import DirtyElementPresentController from "./dirty_element_present_controller"
application.register("dirty-element-present", DirtyElementPresentController)

import DisableOnSubmitController from "./disable_on_submit_controller"
application.register("disable-on-submit", DisableOnSubmitController)

import DynamicTableHeaderController from "./dynamic_table_header_controller"
application.register("dynamic-table-header", DynamicTableHeaderController)

import EditableListController from "./editable_list_controller"
application.register("editable-list", EditableListController)

import ElementSwitcherController from "./element_switcher_controller"
application.register("element-switcher", ElementSwitcherController)

import FetchController from "./fetch_controller"
application.register("fetch", FetchController)

import FlatpickrButtonController from "./flatpickr_button_controller"
application.register("flatpickr-button", FlatpickrButtonController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FormListItemController from "./form_list_item_controller"
application.register("form-list-item", FormListItemController)

import FormStepController from "./form_step_controller"
application.register("form-step", FormStepController)

import HcaptchaInitController from "./hcaptcha_init_controller"
application.register("hcaptcha-init", HcaptchaInitController)

import HideIfController from "./hide_if_controller"
application.register("hide-if", HideIfController)

import HideWhenOnlyOneController from "./hide_when_only_one_controller"
application.register("hide-when-only-one", HideWhenOnlyOneController)

import HorizontalScrollController from "./horizontal_scroll_controller"
application.register("horizontal-scroll", HorizontalScrollController)

import HoverOverlayController from "./hover_overlay_controller"
application.register("hover-overlay", HoverOverlayController)

import HoverOverlayTemplateController from "./hover_overlay_template_controller"
application.register("hover-overlay-template", HoverOverlayTemplateController)

import ImaskController from "./imask_controller"
application.register("imask", ImaskController)

import InputDurationController from "./input_duration_controller"
application.register("input-duration", InputDurationController)

import InputFilterController from "./input_filter_controller"
application.register("input-filter", InputFilterController)

import InputIncrementController from "./input_increment_controller"
application.register("input-increment", InputIncrementController)

import InputQuantityController from "./input_quantity_controller"
application.register("input-quantity", InputQuantityController)

import InputToLinkController from "./input_to_link_controller"
application.register("input-to-link", InputToLinkController)

import ItemCounterController from "./item_counter_controller"
application.register("item-counter", ItemCounterController)

import ItemsFilterController from "./items_filter_controller"
application.register("items-filter", ItemsFilterController)

import ListEmptyMessageController from "./list_empty_message_controller"
application.register("list-empty-message", ListEmptyMessageController)

import ListGroupController from "./list_group_controller"
application.register("list-group", ListGroupController)

import ListItemCheckedHighlightController from "./list_item_checked_highlight_controller"
application.register("list-item-checked-highlight", ListItemCheckedHighlightController)

import ListSearchController from "./list_search_controller"
application.register("list-search", ListSearchController)

import ListSwitcherController from "./list_switcher_controller"
application.register("list-switcher", ListSwitcherController)

import MasonryController from "./masonry_controller"
application.register("masonry", MasonryController)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import NestedAttributeDestroyableController from "./nested_attribute_destroyable_controller"
application.register("nested-attribute-destroyable", NestedAttributeDestroyableController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NestedModelController from "./nested_model_controller"
application.register("nested-model", NestedModelController)

import PopperController from "./popper_controller"
application.register("popper", PopperController)

import PortfolioEntryController from "./portfolio_entry_controller"
application.register("portfolio-entry", PortfolioEntryController)

import RadioListController from "./radio_list_controller"
application.register("radio-list", RadioListController)

import RangeSliderController from "./range_slider_controller"
application.register("range-slider", RangeSliderController)

import ReportDateController from "./report_date_controller"
application.register("report-date", ReportDateController)

import RequireOneController from "./require_one_controller"
application.register("require-one", RequireOneController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import ScrollToHeaderController from "./scroll_to_header_controller"
application.register("scroll-to-header", ScrollToHeaderController)

import SearchableController from "./searchable_controller"
application.register("searchable", SearchableController)

import SearchableParamController from "./searchable_param_controller"
application.register("searchable-param", SearchableParamController)

import SelectFormActionController from "./select_form_action_controller"
application.register("select-form-action", SelectFormActionController)

import SelectSectionController from "./select_section_controller"
application.register("select-section", SelectSectionController)

import SetTurboFrameSrcController from "./set_turbo_frame_src_controller"
application.register("set-turbo-frame-src", SetTurboFrameSrcController)

import ShowSectionIfController from "./show_section_if_controller"
application.register("show-section-if", ShowSectionIfController)

import SortListController from "./sort_list_controller"
application.register("sort-list", SortListController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SpreadsheetController from "./spreadsheet_controller"
application.register("spreadsheet", SpreadsheetController)

import StreamableController from "./streamable_controller"
application.register("streamable", StreamableController)

import SubmitValuesController from "./submit_values_controller"
application.register("submit-values", SubmitValuesController)

import TableRowDetailController from "./table_row_detail_controller"
application.register("table-row-detail", TableRowDetailController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TemplateController from "./template_controller"
application.register("template", TemplateController)

import TimelineController from "./timeline_controller"
application.register("timeline", TimelineController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TurboFormController from "./turbo_form_controller"
application.register("turbo-form", TurboFormController)

import TurboModalController from "./turbo_modal_controller"
application.register("turbo-modal", TurboModalController)

import UpdateOrderAttributeController from "./update_order_attribute_controller"
application.register("update-order-attribute", UpdateOrderAttributeController)

import UploadFilesController from "./upload_files_controller"
application.register("upload-files", UploadFilesController)
